import { RootNavigator } from './root';

export default RootNavigator;
